export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
            <path d="M18.6667 15.1665V19.8332" stroke="#F7A40A" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M28 15.1665V19.8332" stroke="#F7A40A" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M37.3333 15.1665V19.8332" stroke="#F7A40A" strokeWidth="2.5" strokeLinecap="round" />
            <path
                d="M19.25 9.9165C19.25 10.2387 18.9888 10.4998 18.6667 10.4998C18.3445 10.4998 18.0833 10.2387 18.0833 9.9165C18.0833 9.59434 18.3445 9.33317 18.6667 9.33317C18.9888 9.33317 19.25 9.59434 19.25 9.9165Z"
                fill="#F7A40A"
                stroke="#F7A40A"
                strokeWidth="2.33333"
            />
            <path
                d="M28.5833 9.9165C28.5833 10.2387 28.3222 10.4998 28 10.4998C27.6778 10.4998 27.4167 10.2387 27.4167 9.9165C27.4167 9.59434 27.6778 9.33317 28 9.33317C28.3222 9.33317 28.5833 9.59434 28.5833 9.9165Z"
                fill="#F7A40A"
                stroke="#F7A40A"
                strokeWidth="2.33333"
            />
            <path
                d="M37.9167 9.9165C37.9167 10.2387 37.6555 10.4998 37.3333 10.4998C37.0112 10.4998 36.75 10.2387 36.75 9.9165C36.75 9.59434 37.0112 9.33317 37.3333 9.33317C37.6555 9.33317 37.9167 9.59434 37.9167 9.9165Z"
                fill="#F7A40A"
                stroke="#F7A40A"
                strokeWidth="2.33333"
            />
            <path
                d="M10.5 23.3333C10.5 22.0447 11.5447 21 12.8333 21H43.1667C44.4553 21 45.5 22.0447 45.5 23.3333V44.3333H10.5V23.3333Z"
                stroke="black"
                strokeWidth="2.5"
            />
            <path d="M7 44.3335H49" stroke="black" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M18.6667 30.3335H37.3333" stroke="black" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
    );
}
